import { useEffect, useState } from "react";

// Turns any .dense-table that does not fit its container into stacked label/value cards (no horizontal scroll).
export function useResponsiveTables() {
  useEffect(() => {
    const seen = new WeakSet();
    const fit = (tbl) => {
      if (!tbl || !tbl.isConnected) return;
      const p = tbl.parentElement;
      tbl.classList.remove("as-cards");
      tbl.classList.toggle("as-cards", tbl.scrollWidth > p.clientWidth + 1);
    };
    const ro = new ResizeObserver((entries) => entries.forEach((e) => fit(e.target._denseTable)));
    const label = (tbl) => {
      const ths = [...tbl.querySelectorAll("thead th")].map((th) => th.textContent.trim());
      tbl.querySelectorAll("tbody tr").forEach((tr) => [...tr.children].forEach((td, i) => {
        const l = ths[i] ?? "";
        if (td.getAttribute("data-label") !== l) td.setAttribute("data-label", l);
      }));
    };
    const scan = () => {
      document.querySelectorAll("table.dense-table").forEach((tbl) => {
        label(tbl);
        if (!seen.has(tbl)) {
          seen.add(tbl);
          tbl.parentElement._denseTable = tbl;
          ro.observe(tbl.parentElement);
        }
        fit(tbl);
      });
    };
    let raf;
    const mo = new MutationObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(scan); });
    mo.observe(document.body, { childList: true, subtree: true });
    scan();
    return () => { mo.disconnect(); ro.disconnect(); cancelAnimationFrame(raf); };
  }, []);
}

export function useIsNarrow(px = 1024) {
  const get = () => typeof window !== "undefined" && window.innerWidth < px;
  const [narrow, setNarrow] = useState(get);
  useEffect(() => {
    const h = () => setNarrow(get());
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [px]);
  return narrow;
}
